import { Table, Typography } from 'antd';
import { AiFillCheckCircle } from 'react-icons/ai';
import { MdCancel } from 'react-icons/md';
import { IConceptCondition } from '../../../interfaces/plan';

interface Props {
    conditions: IConceptCondition[];
    loading: boolean;
}

const { Text } = Typography;

const TableConditions = ({ conditions, loading }: Props) => {
    const columns: { title: string; dataIndex: string; key: string, render?: (data: any) => React.ReactNode }[] = [
        {
            title: 'Field',
            dataIndex: 'field',
            key: 'field',
            render: (field: string) => (
                <Text style={{ color: '#e5a500' }}>
                    {field}
                </Text>
            ),
        },
        {
            title: 'Operator',
            dataIndex: 'operator',
            key: 'operator',
            render: (operator: string) => (
                <Text style={{ color: '#FFF' }}>{operator}</Text>
            ),
        },
        {
            title: 'Value',
            dataIndex: 'value',
            key: 'value',
            render: (value: string) => (
                <Text style={{ color: '#6C8EEF' }}>{value}</Text>
            ),
        },
        {
            title: 'Booking Value',
            dataIndex: 'bookingValue',
            key: 'bookingValue',
        },
        {
            title: 'Result',
            dataIndex: 'result',
            key: 'result',
            render: (data: boolean) => (
                data ? <AiFillCheckCircle color="green" size={25} /> : <MdCancel color="red" size={25} />
            ),
        },
    ];

    return (
        <Table
            dataSource={conditions}
            columns={columns}
            loading={loading}
            scroll={{ x: 800 }}
        />
    );
};

export default TableConditions;
